import {ChoicesFactory} from "@main/factories/ChoicesFactory";

document.querySelectorAll(".js-select").forEach((el) => ChoicesFactory.create(el));
